// @flow
import * as React from "react";
import Utilities from "../../utils/Utilities";
import { Menu, MenuDivider, MenuItem, Popover, PopoverInteractionKind, Position, Tooltip, AnchorButton, Icon } from "@blueprintjs/core";

export default ({ controller, action, userIsAccountOwner, account, isManager }) => {
  const is360Action = [
    'template_builder',
    'assign_employees',
    'review_360',
    'review_360_report',
    'review_360_report_user',
  ].includes(action);

  return (
    <Popover
      portalContainer={document.body}
      position={Position.RIGHT}
      boundary="viewport"
      interactionKind={PopoverInteractionKind.HOVER}
      popoverClassName="sidebar-submenu-popover"
      content={
        <Menu className="sidebar-submenu-menu">
          <li className="bp3-menu-header">
            <h6 className="bp3-heading">Performance</h6>
          </li>
          <MenuDivider />

          <MenuItem
            text="My Performance"
            icon={<Icon icon="timeline-line-chart" iconSize={14} />}
            onClick={() => Utilities.navigate("/performance/myassessment")}
            href="/performance/myassessment"
          />
         
          {/* <MenuItem 
              text="Team Goals" 
              icon="credit-card" 
              href="/goals/peer" 
              onClick={() => Utilities.navigate("/goals/peer")} 
            />
          {userIsAccountOwner && (
            <MenuItem 
              text="Settings" 
              icon="credit-card" 
              href="/goals/settings" 
              onClick={() => Utilities.navigate("/goals/settings")} 
            />
          )} */}
        </Menu>
      }
    >
      <AnchorButton
        className="bp3-minimal bp3-sidebar-button"
        active={!is360Action && ((controller && controller === 'reviews') || (action && action.includes('performance')))}
        text="Performance"
        href="/performance/myassessment"
        onClick={() => Utilities.navigate('/performance/myassessment')}
        icon={<Icon icon="timeline-events" iconSize={14} />}
        rightIcon="chevron-right"
      />
    </Popover>
  );
};
